import { z } from 'zod';
import { TFunction } from 'i18next';

export const getConsignmentLineDetailsFormSchema = (t: TFunction, hasSubprojects = false) =>
  z.object({
    productCategory: z.string().min(1, t('validation.required', 'Field is required')),
    inventoryQuantity: z.number().min(1, t('validation.minValue', 'Must be greater than 0')),
    productLtuId: z.string().min(1, t('validation.required', 'Field is required')),
    description: z.string().min(1, t('validation.required', 'Field is required')),

    handlingUnits: z.number().min(1, t('validation.minValue', 'Must be greater than 0')),
    handlingUnitTypeId: z.string().min(1, t('validation.required', 'Field is required')),

    totalWeight: z.number().min(0.01, t('validation.minValue', 'Must be greater than 0')),
    totalVolume: z.number().min(0.01, t('validation.minValue', 'Must be greater than 0')),
    totalValue: z.number().min(0, t('validation.minValue', 'Must be 0 or greater')).optional(),

    ownerReference: z.string().optional(),
    expiryDate: z.string().optional(),
    batchNumber: z.string().optional(),
    productCode: z.string().optional(),
    subProjectCode: hasSubprojects
      ? z.string().min(1, t('validation.required', 'Field is required'))
      : z.string().optional(),

    optionalField1: z.string().nullable().optional(),
    optionalField2: z.string().nullable().optional(),
    optionalField3: z.string().nullable().optional(),
    optionalField4: z.string().nullable().optional(),
    optionalField5: z.string().nullable().optional(),
    optionalField6: z.string().nullable().optional(),

    fragile: z.boolean(),
    dangerous: z.boolean(),
    regulated: z.boolean(),
    coldChain: z.boolean(),
    coldMinTemp: z.number().nullable().optional(),
    coldMaxTemp: z.number().nullable().optional(),
    dangerousGoodsUnNumber: z.string().optional(),
    handlingInstructions: z.string().optional(),
    showOnPackingList: z.boolean().optional()
  });
